import { NavLink } from "react-router-dom";
import { useRef } from "react";
import classes from "./MainNavigation.modules.css";
import { FaBars, FaTimes } from "react-icons/fa";
//https://github.com/Index-Zero-0/Responsive-navbar-ReactJS/blob/main/src/Styles/main.css
//https://www.youtube.com/watch?app=desktop&v=amf18mxNX18

function MainNavigation() {
    const navRef = useRef();

    const showNavbar = () => {
        navRef.current.classList.toggle(
            "responsive_nav"
        );
    };
    return (


        <>
            <header>
                <h3 className={classes.logo}>
                    <NavLink to="/" onClick={showNavbar}>
                        Call Me By Your Meme
                    </NavLink>
                </h3>
                <nav ref={navRef}>
                    <NavLink to="/" className={({ isActive }) => (isActive ? "active" : "")} onClick={showNavbar}>
                        Home
                    </NavLink>
                    <NavLink to="/about" className={({ isActive }) => (isActive ? "active" : "")} onClick={showNavbar}>
                        About
                    </NavLink>
                    <NavLink to="/gallery" className={({ isActive }) => (isActive ? "active" : "")} onClick={showNavbar}>
                        Gallery
                    </NavLink>
                    <NavLink to="/bibliography" className={({ isActive }) => (isActive ? "active" : "")} onClick={showNavbar}>
                        Bibliography
                    </NavLink>
                    <NavLink to="/submissions" className={({ isActive }) => (isActive ? "active" : "")} onClick={showNavbar}>
                        Submissions
                    </NavLink>
                    <button
                        className="nav-btn nav-close-btn"
                        onClick={showNavbar}>
                        <FaTimes />
                    </button>
                </nav>
                <button
                    className="nav-btn"
                    onClick={showNavbar}>
                    <FaBars />
                </button>
            </header>
        </>

    )

}
export default MainNavigation;
